var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SemesterForm',{attrs:{"id":_vm.id,"can-create":_vm.can_create_semesters,"can-delete":_vm.can_delete_semesters,"can-edit":_vm.can_edit_semesters,"edit":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }